export const APPACADEMY_EVENT_ID = 150;
export const APPACADEMY_BASE_URL = "https://appacademy.gi.org/appmodules/";

export const isAppUser = (userData) => {
    return userData?.rstatus?.toUpperCase() === "APP";
};

export const isAppAcademyModule = (doc) => {
    return parseInt(doc?.event_id, 10) === APPACADEMY_EVENT_ID && 
           doc?.education_media_type === "module";
};

export const getAppAcademyUrl = (doc) => {
    const id = doc.content_id?.replace("module_", "") || doc.original_id;
    return APPACADEMY_BASE_URL + id;
};

export const shouldRedirectToAppAcademy = (userData, doc) => {
    return isAppUser(userData) && isAppAcademyModule(doc);
};

